type PermissionChecker = (permission: string) => boolean;

type SensitivePermissionKey = 'budget';

const SENSITIVE_PERMISSION_CANDIDATES: Record<SensitivePermissionKey, string[]> = {
  budget: [
    'budget:view',
    'project:budget:view',
    'project:cost:view',
    'cost:view',
    'finance:view',
    'financial:view'
  ]
};

export function hasSensitivePermission(
  checkPermission: PermissionChecker,
  key: SensitivePermissionKey
): boolean {
  return SENSITIVE_PERMISSION_CANDIDATES[key].some((permission) => checkPermission(permission));
}
